
import { FicheToRue, FicheToString, FicheFullToString} from './StringUtils'
import { EnumTypeMedecin, EnumTypeEtablissement } from './generated/Constants'
import { EnumTypeContact } from './EnumApp'

export const FicheToObjectMeta = function (item) {

    let root = ''

    try {

        let adresseRue = FicheToRue(item)
        let descMed = FicheToString(item)
        let descFullMed = FicheFullToString(item)

        let tel = null
        let email = null

        root = {
            "@context": 'http://schema.org/',
            "@type": null,
            "name": descMed,
            "description": descFullMed,
            "numberOfEmployees": {
                "@type": "QuantitativeValue",
                "value": "1"
            },
            "priceRange": null,
            "address": {
                "@type": "PostalAddress",
                "addressCountry": "Algérie",
                "addressLocality": ((item.Wilaya != null && (!item.Wilaya.isEmpty())) ? item.Wilaya : null),
                "postalCode": ((item.CodePostal != null && (!item.CodePostal.isEmpty())) ? item.CodePostal : null),
                "streetAddress": adresseRue,
                "description": descMed,
                "mainEntityOfPage": 'https://algerie-docto.com/' + item.UrlRelatif,
                "name": descMed
            },
            "image": (((item.Images != null) && (item.Images.length > 0)) ? item.Images[0] : 'https://algerie-docto.com/images/logo.png')
        }

        // Medecin
        if (item.IdTypeFiche === 1)
        {
            // Si dentiste
            if (item.IdTypeMedecin === EnumTypeMedecin.Chirurgiedentaire.Code) {
                root['@type'] = "Dentist"
                root['priceRange'] = "2000 DA - 2500 DA"

            }else {
                root['@type'] = "Physician"
                root['priceRange'] = "1000 DA - 1500 DA"
            }
        } else {
            // Etablissement
            if (item.IdTypeFiche === 2) {
                if (item.IdTypeEtablissement === EnumTypeEtablissement.Pharmacie.Code) {
                    root['@type'] = "Pharmacy"
                    root['priceRange'] = "Prix non spécifié"
                } else {
                    if (
                        (item.IdTypeEtablissement === EnumTypeEtablissement.Clinique.Code)
                        || (item.IdTypeEtablissement === EnumTypeEtablissement.Maternite.Code)
                        || (item.IdTypeEtablissement === EnumTypeEtablissement.Centreperinatal.Code)
                        || (item.IdTypeEtablissement === EnumTypeEtablissement.CHU.Code)
                        || (item.IdTypeEtablissement === EnumTypeEtablissement.Hopitalspecialise.Code)
                        || (item.IdTypeEtablissement === EnumTypeEtablissement.Hopitaldeproximite.Code)
                        || (item.IdTypeEtablissement === EnumTypeEtablissement.EPH.Code)
                        || (item.IdTypeEtablissement === EnumTypeEtablissement.EPHU.Code)
                        || (item.IdTypeEtablissement === EnumTypeEtablissement.Hopitalmilitaire.Code)
                        ) {
                        root['@type'] = "Hospital"
                        root['priceRange'] = "Prix non spécifié"

                    } else {
                        if (item.IdTypeEtablissement === EnumTypeEtablissement.Laboratoire.Code) {
                            root['@type'] = "DiagnosticLab"
                            root['priceRange'] = "Prix non spécifié"

                        } else {
                            root['@type'] = "MedicalOrganization"
                            root['priceRange'] = "Prix non spécifié"
                        }
                    }
                }
            } else {
                // Service
                root['@type'] = "MedicalBusiness"
                root['priceRange'] = "Prix non spécifié"
            }
        }

        let telTrouve = false
        let emailTrouve = false
        //let contactsTmp = JSON.parse(item.Contacts)
        let contactsTmp = item.Contacts
        if ((contactsTmp != null) && (contactsTmp != undefined)) {

            root.contactPoint = {
                '@type': 'ContactPoint',
                'contactType': 'customer service',
                'telephone': null,
                'email': null,
            }

            for (var i = 0; i < contactsTmp.length; i++) {

                if ((!telTrouve) && (contactsTmp[i].IdTypeContact === EnumTypeContact.Telephone.value)) {

                    let phoneClean = contactsTmp[i].Valeur

                    // Phone ex
                    if ((phoneClean != null) && (!phoneClean.isEmpty())) {

                        // trim
                        phoneClean = phoneClean.replace(/\s/g, '')

                        if (phoneClean.indexOf('/') > -1) {
                            phoneClean = phoneClean.split("/")[0]
                        }
                    }

                    // Try format
                    try {
                        root.address.telephone = phoneClean
                        root.contactPoint.telephone = phoneClean
                        root.telephone = phoneClean

                    } catch (e) {
                        console.log("Exception microdata FicheToObjectMeta", e)
                    }
                }
                if ((!emailTrouve) && (contactsTmp[i].IdTypeContact === EnumTypeContact.Email.value)) {
                    root.address.email = contactsTmp[i].Valeur
                    root.contactPoint.email = contactsTmp[i].Valeur
                }
            }
        }

        if (item.Images != null) {
            root['image'] = {
                "@type": "ImageObject",
                "caption": descMed,
                "contentUrl": JSON.parse(item.Images)[0].UrlAbsolue,
                "description": descFullMed,
                "name": descMed
            }
        }

        if ((item.Latitude != null) && (item.Longitude != null)) {
            root['geo'] = {
                "@type": "GeoCoordinates",
                "latitude": item.Latitude,
                "longitude": item.Longitude
            }
        }

    } catch (e) {
        console.log("Exception microdata FicheToObjectMeta", e)
    }

    return root
}

export const FichesToMeta = function (items) {

    const schema = {
        type: 'application/ld+json',
        innerHTML: JSON.stringify('')
    }

    let roots = [] 
    for (var itemTmp in items) {
        // Add all items
        roots.push(FicheToObjectMeta(items[itemTmp]))
    }

    // Apply res
    schema.innerHTML = JSON.stringify(roots)

    return [schema]
}

export const FicheToMeta = function (item) {

    const schema = {
        type: 'application/ld+json',
        innerHTML: JSON.stringify('')
    }

    let root = FicheToObjectMeta(item)

    // Apply res
    schema.innerHTML = JSON.stringify(root)

    return [schema]
}
